export default "__VITE_ASSET__BlLR2sTq__"